// extracted by mini-css-extract-plugin
export var container = "RejectNote-module--container--wZ6WL";
export var textarea = "RejectNote-module--textarea--pdfjR";
export var title = "RejectNote-module--title--QIcZm";